// Builds a CSV client-side from data already rendered on screen (headers +
// per-row accessor functions), so the download always matches the table
// exactly instead of drifting from a separately-formatted server export.
export function downloadCsv(filename, columns, rows) {
  const escape = (v) => {
    const s = v == null ? "" : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [columns.map(([label]) => escape(label)).join(",")];
  rows.forEach((row) => {
    lines.push(columns.map(([, get]) => escape(get(row))).join(","));
  });
  const csv = lines.join("\n");
  // Leading BOM so Excel renders Devanagari (UTF-8) text correctly instead of garbling it.
  const BOM = String.fromCharCode(0xfeff);
  const blob = new Blob([BOM + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
